// extracted by mini-css-extract-plugin
module.exports = {"list":"expandableLinks_list__VfP98","listItem":"expandableLinks_listItem__7FUP6"};